import { ScheduleTypeEnum } from 'constants-visitor-management';
import { DateTime } from 'luxon';

const getTimeOfDayMs = (date: Date, timeZone?: string): number => {
  const zoned = timeZone
    ? DateTime.fromJSDate(date).setZone(timeZone)
    : DateTime.fromJSDate(date).toUTC();

  return (
    ((zoned.hour * 60 + zoned.minute) * 60 + zoned.second) * 1000 +
    zoned.millisecond
  );
};

export const validateVisitorScheduleRange = (
  interaction: {
    features: {
      VisitorManagement?: {
        schedule?: {
          type?: string;
          isAllDay?: boolean;
          startDate?: Date;
          endDate?: Date;
        };
      };
    };
  },
  timeZone?: string
) => {
  const schedule = interaction?.features?.VisitorManagement?.schedule;

  if (schedule?.isAllDay) {
    return true;
  }

  if (!schedule?.startDate || !schedule?.endDate) return false;

  // DateRange/Repeat/CustomDates schedules generate one pass per day using
  // the start/end time of day, independent of how many calendar days apart
  // startDate/endDate are - so an equal (or reversed) time of day produces
  // a zero-duration pass on every occurrence, even though the raw
  // startDate/endDate instants themselves are valid (start < end). Time of
  // day must be compared in the property's local timezone: comparing raw
  // UTC hours incorrectly rejects local end times that roll past UTC
  // midnight (e.g. 8pm+ in America/New_York).
  if (
    schedule.type === ScheduleTypeEnum.DateRange ||
    schedule.type === ScheduleTypeEnum.Repeat ||
    schedule.type === ScheduleTypeEnum.CustomDates
  ) {
    return (
      getTimeOfDayMs(schedule.startDate, timeZone) <
      getTimeOfDayMs(schedule.endDate, timeZone)
    );
  }

  return schedule.startDate.getTime() < schedule.endDate.getTime();
};
